import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { themeSettings } from "theme";
import Dashboard from "scenes/dashboard";
import Layout from "scenes/layout";
import Cars from "scenes/inventory/cars";
import Sales from "scenes/sales";
import Transactions from "scenes/sales/transactions";
import Invoices from "scenes/sales/invoices";
import Enquiries from "scenes/enquiries";
import Login from "scenes/Login/login";
import Register from "scenes/Register/register";
import ViewEnquiry from "scenes/enquiries/ViewEnquiry";
import ProductPage from "scenes/CarDetailsPage/index";
import Expenses from "scenes/expenses";
import ProtectedRoute from "routing/ProtectedRoute";
import UserHeader from "routing/UserHeader";
import RoleBasedRoute from "routing/RoleBasedRoute";
import UserList from "scenes/management/UserList";
import InitiateTransaction from "scenes/sales/transactions/initiate";
import ProcessTransaction from "scenes/sales/transactions/process";
import RtoTab from "scenes/sales/rto";
import InsuranceTab from "scenes/sales/insurance";
import ProcessTransactionInsurance from "scenes/sales/insurance/process";
import ProcessTransactionRTO from "scenes/sales/rto/process";

function App() {
  const mode = useSelector((state) => state.global.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);

  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <UserHeader />
          <Routes>
            <Route path="/login" element={<Login />}></Route>
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<Layout />}>
                <Route
                  path="/register"
                  element={
                    <RoleBasedRoute Roles={["Admin"]}>
                      <Register />
                    </RoleBasedRoute>
                  }
                />
                <Route
                  path="/"
                  element={<Navigate to="/dashboard" replace />}
                />
                <Route exact path="dashboard" element={<Dashboard />} />
                <Route
                  path="inventory"
                  element={<Navigate to="/inventory/cars" replace />}
                />

                <Route path="inventory-list" element={<Cars />} />
                <Route path="inventory-view" element={<ProductPage />} />

                <Route
                  path="sales"
                  element={<Navigate to="/sales-overview" replace />}
                />
                <Route
                  path="sales-overview"
                  element={
                    <RoleBasedRoute
                      Roles={["Admin", "Sales Manager", "Sales Consultant"]}
                    >
                      <Sales />
                    </RoleBasedRoute>
                  }
                />
                <Route
                  path="transaction-initiate"
                  element={
                    <RoleBasedRoute
                      Roles={["Admin", "Accountant"]}
                    >
                      <InitiateTransaction />
                    </RoleBasedRoute>
                  }
                />
                <Route
                  path="transaction-process"
                  element={
                    <RoleBasedRoute
                      Roles={["Admin", "Accountant"]}
                    >
                      <ProcessTransaction />
                    </RoleBasedRoute>
                  }
                />
                <Route
                  path="transaction-rto-process"
                  element={
                    <RoleBasedRoute Roles={["Admin"]}>
                      <ProcessTransactionRTO />
                    </RoleBasedRoute>
                  }
                />
                <Route
                  path="transaction-insurance-process"
                  element={
                    <RoleBasedRoute Roles={["Admin"]}>
                      <ProcessTransactionInsurance />
                    </RoleBasedRoute>
                  }
                />
                <Route
                  path="sales-transactions"
                  element={
                    <RoleBasedRoute
                      Roles={["Admin", "Accountant"]}
                    >
                      <Transactions />
                    </RoleBasedRoute>
                  }
                />
                <Route
                  path="sales-invoices"
                  element={
                    <RoleBasedRoute
                      Roles={["Admin", "Accountant"]}
                    >
                      <Invoices />
                    </RoleBasedRoute>
                  }
                />
                <Route
                  path="rto-tab"
                  element={
                    <RoleBasedRoute Roles={["Admin", "RTO Agent"]}>
                      <RtoTab />
                    </RoleBasedRoute>
                  }
                />
                <Route
                  path="insurance-tab"
                  element={
                    <RoleBasedRoute Roles={["Admin", "Insurance Agent", "RTO Agent"]}>
                      <InsuranceTab />
                    </RoleBasedRoute>
                  }
                />
                <Route
                  path="enquiry"
                  element={<Navigate to="/enquiry-overview" replace />}
                />

                <Route
                  path="enquiry-overview"
                  element={
                    <RoleBasedRoute
                      Roles={["Admin", "Sales Manager", "Sales Consultant"]}
                    >
                      <Enquiries />
                    </RoleBasedRoute>
                  }
                />
                <Route
                  path="enquiry-view"
                  element={
                    <RoleBasedRoute
                      Roles={["Admin", "Sales Manager", "Sales Consultant"]}
                    >
                      <ViewEnquiry />
                    </RoleBasedRoute>
                  }
                />
                <Route
                  path="expenses-overview"
                  element={
                    <RoleBasedRoute
                      Roles={["Admin", "Accountant", "Workshop Staff"]}
                    >
                      <Expenses />
                    </RoleBasedRoute>
                  }
                />

                <Route
                  path="management"
                  element={<Navigate to="/management-overview" replace />}
                />
                {/* <Route
                  path="management-overview"
                  element={<h1>Management</h1>}
                /> */}
                <Route path="management-list" element={<UserList />} />
              </Route>
            </Route>
            {/* 404 route */}
            <Route
              path="*"
              element={
                // tailwind styles
                <div className="flex flex-col items-center justify-center h-screen">
                  <h1 className="text-4xl font-bold">404</h1>
                  <p className="text-2xl">Page not found</p>
                </div>
              }
            />
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
